const modalCallbacks = [];

// Register a callback that targets a specific element (by CSS selector)
function registerModalCallback(selector, callback) {
    modalCallbacks.push({ selector, callback });
}

// Execute callbacks only when the target element is found in the newly added nodes
function executeModalCallbacks(node) {
    modalCallbacks.forEach(({ selector, callback }) => {
        const targetElement = node.querySelector(selector) || (node.matches && node.matches(selector) ? node : null);
        if (targetElement) {
            try {
                callback(targetElement);
            } catch (error) {
                console.error("Error executing callback:", error);
            }
        }
    });
}

// Create a MutationObserver to detect when new elements are added
const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Only process element nodes
                executeModalCallbacks(node);
            }
        });
    });
});

// Start observing the remoteModal element
const rootEl = document.querySelector('body');
if (rootEl) {
    observer.observe(rootEl, { childList: true, subtree: true });
}

// ----- DYNAMIC FUNCTIONS -----
// Register the task creation form handling function
registerModalCallback('#taskCreateForm', createTaskFn);
registerModalCallback('#manageEmployeeForm', manageEmployeeFn);
